// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b59912b7","453":"4ecf23b7","455":"52a7daa9","977":"2fa8ba0d"}[chunkId] + ".chunk.js";
};